import { Navigate } from 'react-router-dom'

import MapLayout from '@App/components/MapLayout/MapLayout'
import NavWrapper from '@App/components/NavWrapper/NavWrapper'
import Login from '@App/pages/Login/Login'
import LoginForm from '@App/pages/Login/LoginForm/LoginForm'
import ForgotPasswordForm from '@App/pages/Login/ForgotPasswordForm/ForgotPasswordForm'
import ResetPasswordForm from '@App/pages/Login/ResetPasswordForm/ResetPasswordForm'
import MissionSetup from '@App/pages/MissionSetup/MissionSetup'
import Environment from '@App/pages/MissionSetup/Environment/Environment'
import EnvironmentForm from '@App/pages/MissionSetup/Environment/EnvironmentForm/EnvironmentForm'
import TrapPlanner from '@App/pages/MissionSetup/TrapPlanner/TrapPlanner'
import BreedingSites from '@App/pages/MissionSetup/BreedingSites/BreedingSites'
import BreedingSitesForm from '@App/pages/MissionSetup/BreedingSites/BreedingSitesForm/BreedingSitesForm'
import Alerts from '@App/pages/Alerts/Alerts'
import AlertOverview from '@App/pages/Alerts/AlertOverview/AlertOverview'
import AlertForm from '@App/pages/Alerts/AlertForm/AlertForm'
import MosquitoObservations from '@App/pages/MosquitoObservations/MosquitoObservations'
import MosquitoObservationsFilter from '@App/pages/MosquitoObservations/MosquitoObservationsFilter/MosquitoObservationsFilter'
import MosquitoObservationsSightingsList from '@App/pages/MosquitoObservations/MosquitoObservationsSightingsList/MosquitoObservationsSightingsList'
import MosquitoObservationsDetectionList from '@App/pages/MosquitoObservations/MosquitoObservationsDetectionList/MosquitoObservationsDetectionList'
import LabResults from '@App/pages/LabResults/LabResults'
import LabResultsList from '@App/pages/LabResults/LabResultsList/LabResultsList'
import LabResultsFilter from '@App/pages/LabResults/LabResultsFilter/LabResultsFilter'
import NoMatch from '@App/pages/NoMatch/NoMatch'

const routes = [
  {
    element: <Login />,
    children: [
      {
        path: '/login',
        element: <LoginForm />,
        handle: { name: 'Login' },
      },
      {
        path: '/forgot-password',
        element: <ForgotPasswordForm />,
        handle: { name: 'Forgot password' },
      },
      {
        path: '/reset-password',
        element: <ResetPasswordForm />,
        handle: { name: 'Reset password' },
      },
    ] },
  {
    element: <NavWrapper />,
    children: [
      {
        element: <MapLayout />,
        path: '/',
        children: [
          {
            path: 'mission-setup',
            element: <MissionSetup />,
            children: [
              {
                path: '',
                element: <Navigate to="environment" replace />,
              },
              {
                path: 'environment',
                element: <Environment />,
                handle: { name: 'Mission setup', actions: ['close'] },
              },
              {
                path: 'environment/add',
                element: <EnvironmentForm />,
                handle: { name: 'Add custom data', actions: ['back'] },
              },
              {
                path: 'trap-planner',
                element: <TrapPlanner />,
                handle: { name: 'Mission setup', actions: ['close'] },
              },
              {
                path: 'breeding-sites',
                element: <BreedingSites />,
                handle: { name: 'Mission setup', actions: ['close'] },
              },
              {
                path: 'breeding-sites/add',
                element: <BreedingSitesForm />,
                handle: { name: 'Add breeding site', actions: ['back'] },
              },
            ],
          },
          {
            path: 'alerts',
            element: <Alerts />,
            children: [
              {
                path: '',
                element: <AlertOverview />,
                handle: { name: 'Alerts', actions: ['close'] },
              },
              {
                path: 'add-alert',
                element: <AlertForm />,
                handle: { name: 'Alerts', actions: ['back'] },
              },
            ],
          },
          {
            path: 'mosquito-observations',
            element: <MosquitoObservations />,
            children: [
              {
                path: '',
                element: <Navigate to="sightings" replace />,
              },
              {
                path: 'sightings',
                element: <MosquitoObservationsSightingsList />,
                handle: { name: 'Mosquito observations', actions: ['filter', 'close'] },
              },
              {
                path: 'detections',
                element: <MosquitoObservationsDetectionList />,
                handle: { name: 'Mosquito observations', actions: ['filter', 'close'] },
              },
              {
                path: 'sightings/filter',
                element: <MosquitoObservationsFilter />,
                handle: { name: 'Mosquito observations', actions: ['filter', 'close'] },
              },
              {
                path: 'detections/filter',
                element: <MosquitoObservationsFilter />,
                handle: { name: 'Mosquito observations', actions: ['filter', 'close'] },
              },
            ],
          },
          {
            path: 'lab-results',
            element: <LabResults />,
            children: [
              {
                path: '',
                element: <LabResultsList />,
                handle: { name: 'Lab results', actions: ['filter', 'close'] },
              },
              {
                path: 'filter',
                element: <LabResultsFilter />,
                handle: { name: 'Lab results', actions: ['filter', 'close'] },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NoMatch />,
  },
]

export default routes
